import { styled, breakpointUp } from '@moonpig/launchpad-utils'
import React from 'react'
import { Orientation } from './types'

const StyledImageContainer = styled.div`
  &::before {
    content: '';
    display: block;
    width: 70%;
    background: linear-gradient(
      90deg,
      rgba(234, 234, 234, 1) 18%,
      rgba(235, 235, 235, 1) 60%,
      rgba(255, 255, 255, 1) 100%
    );
    position: absolute;
  }
`

const StyledPortraitImageContainer = styled(StyledImageContainer)`
  transform: skew(0, 2deg) translate3d(-3px, -8px, 0);

  &::before {
    height: 50px;
    left: 13px;
    top: -3%;

    ${breakpointUp('sm')} {
      left: 17px;
    }

    ${breakpointUp('md')} {
      left: 5%;
    }

    transform: skew(0, -6deg) translateZ(0);
  }
`

const StyledLandscapeImageContainer = styled(StyledImageContainer)`
  transform: skew(-2deg, 0) translate3d(-3px, -8px, 0);

  &::before {
    height: 70%;
    right: 2px;
    top: 0;
    transform: skew(8deg, 0) translateZ(0);
  }
`

export const CardImageOrientationWrapper: React.FC<{
  orientation: Orientation
  children: React.JSX.Element
}> = ({ orientation, children }) => {
  switch (orientation) {
    case Orientation.Landscape:
      return (
        <StyledLandscapeImageContainer>
          {children}
        </StyledLandscapeImageContainer>
      )
    default:
      return (
        <StyledPortraitImageContainer>{children}</StyledPortraitImageContainer>
      )
  }
}
